import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import PropertyDetailView from './PropertyDetailView';
import { API_BASE } from './lib/runtimeConfig';

export default function PropiedadPublica({ auth, settings }) {
    const { slug } = useParams();
    const navigate = useNavigate();
    const [property, setProperty] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetch(`${API_BASE}/api/properties/slug/${slug}`)
            .then(r => {
                if (!r.ok) throw new Error('Propiedad no encontrada');
                return r.json();
            })
            .then(data => { setProperty(data); setLoading(false); document.title = `${data.title} | Vyara Group`; })
            .catch(err => { setError(err.message); setLoading(false); });
    }, [slug]);

    if (loading) return (
        <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f8fafc' }}>
            <div style={{ textAlign: 'center' }}>
                <div style={{ width: 48, height: 48, border: '4px solid #003366', borderTopColor: 'transparent', borderRadius: '50%', animation: 'spin 0.8s linear infinite', margin: '0 auto 16px' }} />
                <p style={{ color: '#64748b', fontFamily: 'Inter, sans-serif' }}>Cargando propiedad…</p>
                <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
            </div>
        </div>
    );

    if (error) return (
        <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', background: '#f8fafc', fontFamily: 'Inter, sans-serif' }}>
            <div style={{ fontSize: 64, marginBottom: 16 }}>🏠</div>
            <h2 style={{ color: '#1e293b', margin: '0 0 8px' }}>Propiedad no encontrada</h2>
            <p style={{ color: '#64748b', margin: '0 0 24px' }}>El enlace puede haber cambiado o la propiedad no está disponible.</p>
            <button onClick={() => navigate('/')} style={{ padding: '12px 28px', background: '#003366', color: '#fff', border: 'none', borderRadius: 10, fontWeight: 700, cursor: 'pointer', fontSize: 15 }}>
                Ver todas las propiedades
            </button>
        </div>
    );

    return <PropertyDetailView property={property} auth={auth} settings={settings} />;
}
